import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './StackGrid.module.css';
import spacingOptions from './spacingOptions';

const StackGrid = ({
  children,
  spacingVertical,
  spacingHorizontal,
  id,
  dataId,
  itemMinWidth,
  itemMinHeight,
}) => {
  const bindClasses = classNameBind.bind(styles);

  return (
    <div
      id={id}
      className={bindClasses(
        'wrapper',
        `spacingVertical-${spacingVertical}`,
        `spacingHorizontal-${spacingHorizontal}`,
      )}
      style={{
        gridTemplateColumns: `repeat(auto-fill, minmax(${itemMinWidth}px, 1fr))`,
        gridTemplateRows: `repeat(auto-fill, minmax(${itemMinHeight}px, auto))`,
        gridAutoRows: `minmax(${itemMinHeight}px, max-content)`,
      }}
      data-ppuc-id={dataId}
    >
      {children}
    </div>
  );
};

StackGrid.defaultProps = {
  children: null,
  spacingVertical: 'default',
  spacingHorizontal: 'default',
  id: null,
  dataId: 'StackGrid',
  itemMinWidth: 200,
  itemMinHeight: 200,
};

StackGrid.propEnums = {
  spacingOptions,
};

export default StackGrid;
